// /web/src/consent/CookieBanner.jsx
import React from "react";
import { useConsent } from "./ConsentContext";
import "./cookie.css";

export default function CookieBanner() {
  const { prefs, setPrefs, showSettings, settingsOpen } = useConsent();
  const hasDecision = prefs.updatedAt > 0;

  if (hasDecision) return null;

  return (
    <div className="pd-cookie-banner" aria-live="polite">
      <div className="pd-cookie-inner">
        <p className="pd-cookie-text">
          Pebbledash uses cookies to improve your experience and to analyse how the platform is used.
          You can accept all cookies or manage your preferences.
        </p>

        <div className="pd-cookie-actions">
          <button
            type="button"
            className="pd-btn pd-btn--primary"
            onClick={() => setPrefs({ essential: true, analytics: true, marketing: true })}
          >
            Accept all
          </button>

          <button
            type="button"
            className="pd-btn pd-btn--ghost"
            onClick={showSettings}
            aria-expanded={settingsOpen}
          >
            Manage settings
          </button>

          <button
            type="button"
            className="pd-btn pd-btn--ghost"
            onClick={() => setPrefs({ essential: true, analytics: false, marketing: false })}
          >
            Reject optional
          </button>
        </div>
      </div>
    </div>
  );
}
